import {useCallback, useContext, useEffect, useState} from 'react';

import {LeftAlignIcon} from '~library/svg/LeftAlignIcon';
import {RightAlignIcon} from '~library/svg/RightAlignIcon';
import {MiddleAlignIcon} from '~library/svg/MiddleAlignIcon';
import {TextFormatAlignmentBase} from '~/common/fabric/CreateDesign/components/CardEditor/actions/TextFormat/components/Alignment/TextFormatAlignmentBase/TextFormatAlignmentBase';
import {FabricContext} from '~/common/fabric/context/FabricContext';

export const Alignment = ({className}) => {
  const {canvas} = useContext(FabricContext);
  const [selectedAlignment, setAlignment] = useState();

  useEffect(() => {
    setAlignment(canvas?.getActiveObjects()?.[0]?.textAlign);
    canvas?.on('object:reset', () => setAlignment(canvas?.getActiveObjects()?.[0]?.textAlign));
  }, [canvas]);

  const changeAlignment = (align) => {
    const activeObjects = canvas?.getActiveObjects();
    activeObjects?.forEach((obj) => {
      setAlignment(align);
      obj.set('textAlign', align);
      canvas.requestRenderAll();
      canvas.fire('object:modified');
    });
  };

  const leftAlignment = useCallback(() => changeAlignment('left'), []);
  const middleAlignment = useCallback(() => changeAlignment('center'), []);
  const rightAlignment = useCallback(() => changeAlignment('right'), []);

  return (
    <div className={className}>
      <TextFormatAlignmentBase
        icon={LeftAlignIcon}
        onClick={leftAlignment}
        active={selectedAlignment === 'left'}
        dataQaId="step1-textformat-leftalign"
      />
      <TextFormatAlignmentBase
        icon={MiddleAlignIcon}
        onClick={middleAlignment}
        active={selectedAlignment === 'center'}
        dataQaId="step1-textformat-centeralign"
      />
      <TextFormatAlignmentBase
        icon={RightAlignIcon}
        onClick={rightAlignment}
        active={selectedAlignment === 'right'}
        dataQaId="step1-textformat-rightalign"
      />
    </div>
  );
};
